import { type CookieOptions, useCookie } from '#app'

import type { StorageLike } from '@packages/persiststate/runtime/types.ts'

function usePersistedstateCookies (cookieOptions?: CookieOptions<string>): StorageLike {
  return {
    getItem: (key) => {
      return useCookie<string>(key, {
        ...cookieOptions,
        readonly: false,
        encode: encodeURIComponent,
        decode: decodeURIComponent,
      }).value
    },
    setItem: (key, value) => {
      useCookie<string>(key, {
        ...cookieOptions,
        readonly: false,
        encode: encodeURIComponent,
        decode: decodeURIComponent,
      }).value = value
    },
  }
}

export const cookiesPersistedState = {
  cookies: usePersistedstateCookies(),
  cookiesWithOptions: usePersistedstateCookies,
}
